import { ParamMap, ResolveFn } from '@angular/router';

/** The crud route parameter: 'new', a positive integer id, or undefined for any other value. */
export function crudParam(paramMap: ParamMap, parameterName: string): 'new' | number | undefined {
  const value = paramMap.get(parameterName);
  if (value === 'new') {
    return value;
  }
  return value !== null && /^[1-9]\d*$/.test(value) ? Number(value) : undefined;
}

export function crudResolver(parameterName: string, key: string = 'id'): ResolveFn<any> {
  return route => {
    const value = crudParam(route.paramMap, parameterName);
    if (value === 'new') {
      return { is_new: true };
    }
    return value === undefined ? undefined : { [key]: value };
  };
}
